<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="surveys">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Encuestas&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-btn small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        @click="onClose"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item @click="onProcessReport">
                                    <v-list-item-title>
                                        <v-icon color="red" @click
                                            >mdi-file-pdf-outline</v-icon
                                        >&nbsp; Generar reporte
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="onClose">
                                    <v-list-item-title>
                                        <v-icon
                                            color="red"
                                            @click="onClose"
                                            >mdi-close</v-icon
                                        >&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                                
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de encuestas y encuesta seleccionada: -->
                    <v-container pa-2 grid-list-md fluid>
                        <!-- Renglón único para lista de encuestas y card de encuesta seleccionada: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de encuestas: *************************** -->
                            <v-flex xs10 sm4 md3>
                                <v-card>
                                    <v-toolbar
                                        dense
                                        color="teal darken-1"
                                        dark
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title"
                                            >Encuestas Realizadas</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-format-list-bulleted</v-icon
                                        >
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-4"
                                        :disabled="loadingSurvey"
                                    >
                                        <v-list-item-group
                                            v-model="selectedSurveyIndex"
                                            color="orange accent-4"
                                            mandatory
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(survey, i) in surveys"
                                                :key="i"
                                                @click="selectSurvey(survey.encuestaid)">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex md2 xs6>
                                                                    {{survey.nombre }}
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Encuestas ********************************* -->

                            <!-- Info de Encuesta seleccionada: *********************** -->
                            <v-flex xs10 sm8 md9>
                                <v-card class="grey lighten-4">
                                    <v-toolbar
                                        dense
                                        color="teal lighten-3"
                                        flat
                                    >
                                        <v-icon
                                            >mdi-clipboard-pulse-outline</v-icon
                                        >
                                        <v-toolbar-title class="my-list-title"
                                            >&nbsp; {{ selectedSurveyName }}</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-toolbar-items class="hidden-sm-and-down">
                                        </v-toolbar-items>
                                        <v-tooltip bottom color="red">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        text
                                                        @click="onProcessReport"
                                                        v-on="on"
                                                        color="blue-grey darken-3"
                                                        icon
                                                    >
                                                        <v-icon color="red darken-2">mdi-file-pdf-box</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Generar reporte</span>
                                            </v-tooltip>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 sm6 md4>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-clipboard-pulse-outline"
                                                        name="name"
                                                        label="Encuestador"
                                                        type="text"
                                                        v-model="surveyUser"
                                                        readonly
                                                        ref="name_field"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-calendar-month"
                                                        name="name"
                                                        label="Fecha de evaluación"
                                                        type="text"
                                                        v-model="surveyDate"
                                                        readonly
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 sm12 md4 lg3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account"
                                                        name="name"
                                                        label="Apellido paterno"
                                                        type="text"
                                                        v-model="surveyLastName1"
                                                        readonly
                                                        ref="lastname_field"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md4 lg3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        name="name"
                                                        label="Apellido materno"
                                                        type="text"
                                                        v-model="surveyLastName2"
                                                        readonly
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                 <v-flex xs12 sm12 md4 lg2>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        name="name"
                                                        label="Nombre"
                                                        type="text"
                                                        v-model="surveyName"
                                                        readonly
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md4 lg2>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account-child"
                                                        :items="ageRanges"
                                                        item-text="rangoEdad"
                                                        item-value="rangoedadid"
                                                        v-model="surveyAgeID"
                                                        label="Edad"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay rangos de edad registrados."
                                                       readonly
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm12 md4 lg2>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-gender-male-female"
                                                        :items="genders"
                                                        item-text="genero"
                                                        item-value="generoid"
                                                        v-model="surveySex"
                                                        label="Sexo"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        readonly
                                                    ></v-select>
                                                </v-flex>
                                                
                                            </v-layout>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 sm12 md4 lg4>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account-tie"
                                                        :items="organizationalLevels"
                                                        item-text="nivelOrganizacional"
                                                        item-value="nivelorganizacionalid"
                                                        v-model="surveyOrgLevelID"
                                                        label="Nivel organizacional"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay niveles registrados."
                                                        readonly   
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm12 md3 lg3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-email"
                                                        name="email"
                                                        label="Correo electrónico"
                                                        type="text"
                                                        v-model="surveyEmail"
                                                        readonly
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md3 lg3>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-translate"
                                                        :items="languages"
                                                        item-text="idioma"
                                                        item-value="idiomaid"
                                                        v-model="surveyLanguageID"
                                                        label="Idioma"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay idiomas registrados."
                                                        readonly
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-card class="mx-auto teal--text text--darken-3">
                                                        <v-card-title pa-0>Resultados</v-card-title>
                                                        <v-divider class="teal darken-3"></v-divider>
                                                        <!-- <v-card-text class="grey lighten-5"> -->
                                                        <v-data-table
                                                                readonly = "true"
                                                                fixed-header
                                                                :headers="resultsHeader"
                                                                :items="resultsTableValues"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                class="elevation-1"
                                                                :show-select="false"
                                                                single-select
                                                                dense
                                                                :items-per-page="14"
                                                            >
                                                                <template #item="{ item }">
                                                                    <tr :class="item.bold === true ? 'bold-row' : 'normal-row'">
                                                                        <td style="text-align:left;">{{ item.concepto }}</td>
                                                                        <td>{{ item.positivos }}</td>
                                                                        <td>{{ item.ppositivos }}</td>
                                                                        <td>{{ item.negativos }}</td>
                                                                        <td>{{ item.pnegativos }}</td>
                                                                        <td>{{ item.total }}</td>
                                                                    </tr> 
                                                                    </template>
                                                            </v-data-table>
                                                       <!-- </v-card-text> -->
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de Encuesta seleccionada *********************** -->
                        </v-layout>

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bShowNotFoundAlert"
                                persistent
                                max-width="30%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Búsqueda de
                                            Encuestas</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>search</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >warning</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    No hay encuestas registradas con ese nombre.
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no hubo resultados en la búsqueda *************************** -->
                        <!-- Modal para para confirmar procesamiento de reporte: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bProcessReportDlg" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Procesar reporte</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-file-pdf</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="red"
                                                >mdi-file-pdf-box</v-icon
                                            >
                                        </div>
                                        ¿Desea generar el reporte de la encuesta seleccionada?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmProcessReport"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelProcessReport"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar procesamiento de reporte *************************** -->

                        <!-- Modal para informar que no se pudo procesar el reporte *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bReportNotCreated"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Reporte no generado</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-alert-circle-outline</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >No se pudo generar el reporte.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bReportNotCreated = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no se pudo procesar el reporte *********************************** -->


                        <!-- Termina renglón único para lista de Sets de Respuestas y set seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de Sets de Respuestas y set seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'surveys',
    data() {
        return {
            bDense: false,
            drawer: false,

            bInvalidData: false,
            errorMessage: '',
            
            surveyUser: '',
            surveyDate: '',
            surveyLastName1: '',
            surveyLastName2: '',
            surveyName: '',
            surveyAgeID: 0,
            surveySex: 0,
            surveyOrgLevelID: 0,
            surveyEmail: '',
            surveyLanguageID: 0,
            bProcessReportDlg: false,

            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
            bReportNotCreated: false, //Indica si el reporte no se pudo generar por algún error.

            //Campos de la encuesta de soporte, no de la BD:
            selectedSurveyName: '',


            resultsHeader: [
                {
                    text: '',
                    sortable: false,
                    align: 'left',
                    value: 'concepto',
                },
                {
                    text: 'Puntos positivos',
                    sortable: false,
                    align: 'right',
                    value: 'positivos',
                },
                {
                    text: '% positivos',
                    sortable: false,
                    align: 'right',
                    value: 'ppositivos'
                },
                {
                    text: 'Puntos negativos',
                    sortable: false,
                    align: 'right',
                    value: 'negativos'
                },
                {
                    text: '% negativos',
                    sortable: false,
                    align: 'right',
                    value: 'pnegativos'
                },
                {
                    text: 'Total',
                    sortable: false,
                    align: 'right',
                    value: 'total'
                }
            ],

            resultsTableValues: [
                {
                    row: 1,
                    bold: false,
                    concepto: 'Inteligencia analítica y de detalle',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 2,
                    bold: false,
                    concepto: 'Claridad del costo-beneficio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0',
                },
                {
                    row: 3,
                    bold: false,
                    concepto: 'Pensamiento de largo plazo',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 4,
                    bold: false,
                    concepto: 'Inteligencia conceptual',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 5,
                    bold: true,
                    concepto: 'Promedio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 6,
                    bold: false,
                    concepto: 'Inteligencia interpersonal',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 7,
                    bold: false,
                    concepto: 'Inteligencia conceptual',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 8,
                    bold: false,
                    concepto: 'Inteligencia social',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 9,
                    bold: true,
                    concepto: 'Promedio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 10,
                    bold: false,
                    concepto: 'Auto-observación/Auto-conocimiento',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 11,
                    bold: false,
                    concepto: 'Capacidad de ajustar comportamiento',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 12,
                    bold: false,
                    concepto: 'Pensamiento ético',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 13,
                    bold: true,
                    concepto: 'Promedio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                },
                {
                    row: 14,
                    bold: true,
                    concepto: 'Gran Promedio',
                    positivos: '0',
                    ppositivos: '0',
                    negativos: '0',
                    pnegativos: '0',
                    total: '0'
                }
            ]
        };
    },
    created() {

        //this.$store.dispatch('initSurveyData'); //Se inicializan los campos de la encuesta.
        this.selectFirstSurvey();
    },
    methods: {
        onClose() {
            this.$router.push('/');
        },
        
        selectFirstSurvey() {
            console.log('selectFirstSurvey, this.surveys =, ', this.surveys);
            if (this.surveys.length > 0)
            {
                this.selectedSurveyIndex = 0;
                var surveyID = this.surveys[this.selectedSurveyIndex].encuestaid;
                this.selectSurvey(surveyID);
            }
            else
            {
                this.selectedSurveyIndex = -1;
                //this.survey.encuestaid = 0;
            }
        },

        selectSurvey(surveyID) {
            this.loadingSurvey = true; //Para no dejar seleccionar otra encuesta antes de que se haya terminado de cargar toda la información.
            this.$store.dispatch('getSurveyData', surveyID);
        },

        onProcessReport() {
            this.bProcessReportDlg = true;
        },

        onConfirmProcessReport() {
            const reportInfo = {
                surveyID: this.survey.encuestaid
            };

            console.log("reportInfo = ", reportInfo);

            this.$store.dispatch('processReport', reportInfo);
            this.bProcessReportDlg = false;
        },

        onCancelProcessReport() {
            this.bProcessReportDlg = false;
        },

        onSearch() {
            if (this.searchText != '') {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.surveys.length; i++) {
                    var strLowerCaseText = this.surveys[i].nombre.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0) {
                        this.selectedSurveyIndex = i;
                        this.selectSurvey(this.surveys[i].encuestaid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'userType',
            'loggedUserID',
            'users',
            'languages',
            'genders',
            'organizationalLevels',
            'ageRanges'
        ]),

        selectedSurveyIndex: {
            get() {
                return this.$store.getters.selectedSurveyIndex;
            },
            set(selectedSurveyIndex) {
                this.$store.dispatch(
                    'updateSelectedSurveyIndex',
                    selectedSurveyIndex
                );
            },
        },

        surveys: {
            get() {
                return this.$store.getters.surveys;
            },
            set(surveys) {
                this.$store.dispatch('updateSurveys', surveys);
            },
        },

        survey: {
            get() {
                return this.$store.getters.survey;
            },
            set(survey) {
                this.$store.dispatch('updateSurvey', survey);
            },
        },

        surveyLoaded: {
            get() {
                return this.$store.getters.surveyLoaded;
            },
            set(surveyLoaded) {
                this.$store.dispatch('updateSurveyLoaded', surveyLoaded);
            },
        },

        loadingSurvey: {
            get() {
                return this.$store.getters.loadingSurvey;
            },
            set(loadingSurvey) {
                this.$store.dispatch('updateLoadingSurvey', loadingSurvey);
            },
        },

        reportProcessed: {
            get() {
                return this.$store.getters.reportProcessed;
            },
            set(reportProcessed) {
                this.$store.dispatch('updateReportProcessed', reportProcessed);
            },
        },

        reportWarning: {
            get() {
                return this.$store.getters.reportWarning;
            },
            set(reportWarning) {
                this.$store.dispatch('updateReportWarning', reportWarning);
            },
        },

        pdfPath: {
            get() {
                return this.$store.getters.pdfPath;
            },
            set(pdfPath) {
                this.$store.dispatch('updatePdfPath', pdfPath);
            },
        },


        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '400px';
            } else {
                height = '700px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '50';
            } else if (this.$vuetify.breakpoint.md) {
                height = '65';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '80';
            } else {
                height = '100';
            }
            return height;
        },
    },
    watch: {
        surveyLoaded: function (value, oldValue) {

            if (this.surveyLoaded)
            {
                this.surveyUser = this.survey.encuestador;
                this.surveyDate = this.survey.fecha;
                this.surveyLastName1 = this.survey.apellidoPaterno;
                this.surveyLastName2 = this.survey.apellidoMaterno;
                this.surveyName = this.survey.nombre;
                this.surveyAgeID = this.survey.edadid;
                this.surveySex = this.survey.generoid;
                this.surveyOrgLevelID = this.survey.nivelorganizacionalid;
                this.surveyEmail = this.survey.correoelectronico;
                this.surveyLanguageID = this.survey.idiomaid;

                var i;
                for (i = 0; i < this.survey.conceptos.length; i ++)
                {
                    this.resultsTableValues[i].positivos = this.survey.conceptos[i].resultados[0];
                    this.resultsTableValues[i].ppositivos = this.survey.conceptos[i].resultados[1];
                    this.resultsTableValues[i].negativos = this.survey.conceptos[i].resultados[2];
                    this.resultsTableValues[i].pnegativos = this.survey.conceptos[i].resultados[3];
                    this.resultsTableValues[i].total = this.survey.conceptos[i].resultados[4];
                }

                this.selectedSurveyName = this.surveyLastName1;
                if (this.surveyLastName2 !== "")
                {
                    this.selectedSurveyName += " " + this.surveyLastName2;
                }
                this.selectedSurveyName += " " + this.surveyName;

                this.surveyLoaded = false;
            }
        },

        reportProcessed: function (value, oldValue) {
            if (this.reportProcessed) {
                this.reportProcessed = false;

                console.log('ReportWarning = ', this.reportWarning);

                if (this.reportWarning === 0 && this.pdfPath !== '') {
                    window.open(this.pdfPath);
                    this.pdfPath = '';
                } else if (this.reportWarning === 1) {
                    this.reportWarning = 0;
                    this.bReportNotCreated = true;
                    this.pdfPath = '';
                }
            }
        },
        
    },
};
</script>

<style scoped>
.sub-window {
    background: rgba(224, 224, 224, 0.6);
}
.surveys {
    background: url('../assets/hunters-race-MYbhN8KaaEc-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

.normal-row{
    font-weight: normal;
    color: black;
    background-color: white;
    text-align: right;
}

.bold-row{
    font-weight: bold;
    color: rgb(4, 104, 104);
    /* background-color: rgb(233, 233, 233); */
    background-color: rgb(228, 248, 248);
    text-align: right;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>